import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from '../../components/header';
import Success from '../../components/success';
import { useEffect } from 'react';

export default function Paid() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { paymentType } = useLocation()?.state || {};
  const handleHome = (e) => navigate('/');

  useEffect(() => {
    if (!paymentType) {
      navigate('/');
    }
  }, []);

  return (
    <>
      <section className='d-flex flex-column justify-content-center align-items-center w-100'>
        <Header />
        <Success
          handleAction={handleHome}
          paymentType={paymentType}
          t={t}
        />
      </section>
    </>
  );
}
